class HubspotForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.submitButton = this.querySelector('button[type="submit"]')
    this.formType = this.getAttribute('form-type')
    this.successMessage = this.getAttribute('success-message')
    this.errorMessage =
      this.getAttribute('error-message') ||
      'There was an error submitting your form. Please try again.'

    this.init()
  }

  init() {
    if (!this.form) return

    this.form.addEventListener('submit', this.handleSubmit.bind(this))
    this.createMessageElements()
  }

  createMessageElements() {
    // Create success message
    const successMessage = document.createElement('div')
    successMessage.className = 'success-message'
    successMessage.style.cssText = 'display: none; color: #009875; margin-top: 8px;'
    successMessage.classList.add('paragraph-md')
    successMessage.textContent = this.successMessage
    this.appendChild(successMessage)

    // Create error message container
    const errorMessage = document.createElement('div')
    errorMessage.className = 'error-message'
    errorMessage.style.cssText = 'display: none; color: #dc3232; margin-top: 8px;'
    errorMessage.classList.add('paragraph-md')
    this.appendChild(errorMessage)
  }

  async handleSubmit(event) {
    event.preventDefault()

    if (this.submitButton) {
      this.submitButton.disabled = true
      this.submitButton.setAttribute('aria-busy', 'true')
    }

    const formData = new FormData(this.form)

    try {
      const endpoint = this.getEndpoint()
      const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
      })

      const result = await response.json()

      if (!response.ok) {
        throw new Error(result.message || this.errorMessage)
      }

      this.showSuccessMessage()
      this.form.reset()
    } catch (error) {
      this.showErrorMessage(error.message || this.errorMessage)
    } finally {
      if (this.submitButton) {
        this.submitButton.disabled = false
        this.submitButton.removeAttribute('aria-busy')
      }
    }
  }

  getEndpoint() {
    const baseUrl = '/wp-json/hubspot/v1'

    switch (this.formType) {
      case 'get-in-touch':
        return `${baseUrl}/get-in-touch`
      case 'newsletter':
        return `${baseUrl}/newsletter`
      case 'intelligence-newsletter':
        return `${baseUrl}/intelligence-newsletter`
      default:
        throw new Error('Invalid form type')
    }
  }

  showSuccessMessage() {
    const successMessage = this.querySelector('.success-message')
    const errorMessage = this.querySelector('.error-message')

    if (errorMessage) {
      errorMessage.style.display = 'none'
    }

    if (successMessage) {
      successMessage.style.display = 'block'
      setTimeout(() => {
        successMessage.style.display = 'none'
      }, 5000)
    }

    // Dispatch a custom event for the contact form to catch
    if (this.formType === 'get-in-touch') {
      const event = new CustomEvent('hubspot-form-success', {
        bubbles: true,
        composed: true,
      })
      this.dispatchEvent(event)
    }
  }

  showErrorMessage(message) {
    const successMessage = this.querySelector('.success-message')
    const errorMessage = this.querySelector('.error-message')

    if (successMessage) {
      successMessage.style.display = 'none'
    }

    if (errorMessage) {
      errorMessage.textContent = message
      errorMessage.style.display = 'block'
      setTimeout(() => {
        errorMessage.style.display = 'none'
      }, 5000)
    }
  }
}

customElements.define('hubspot-form', HubspotForm)
